// This file can be replaced during build by using the `fileReplacements` array.
// `ng build --prod` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.

export let environment = {
  production: false,
  advCorpLoginApi: "",
  advFirmasWebApi: "",
  AdvFirmasWebApiCertificate: "",
  versao: "",
  token: null,
  expiracao: null,
  usuario: "",
  senha: "",
  empresa: "ADVICE",
  id_autorizador: "",
  nr_cpf_autorizador: "",
  cd_usuario: "",
  cd_login: "",
  tema_css: "black",
  logo: ""
};

/*
 * For easier debugging in development mode, you can import the following file
 * to ignore zone related error stack frames such as `zone.run`, `zoneDelegate.invokeTask`.
 *
 * This import should be commented out in production mode because it will have a negative impact
 * on performance if an error is thrown.
 */
// import 'zone.js/dist/zone-error';  // Included with Angular CLI.
